function bytesToBase64Url(bytes) {
    let binary = "";
    for (let i = 0; i < bytes.length; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary)
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/, "");
}
function stringToBase64Url(value) {
    return bytesToBase64Url(new TextEncoder().encode(value));
}
function pkcs8ToDer(privateKey) {
    const body = privateKey
        .replace(/-----BEGIN [^-]+-----/g, "")
        .replace(/-----END [^-]+-----/g, "")
        .replace(/\\[nrt]/g, "")
        .replace(/\s+/g, "");
    const binary = atob(body);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return bytes.buffer;
}
function describe(e) {
    const err = e;
    const name = err?.name || "Error";
    const message = err?.message;
    return message ? `${name}: ${message}` : name;
}
export function canSignWidgetJwt() {
    return (typeof globalThis.crypto !== "undefined" &&
        typeof globalThis.crypto.subtle !== "undefined" &&
        typeof globalThis.btoa === "function" &&
        typeof globalThis.atob === "function");
}
export async function signWidgetMintJwt(claims, privateKey) {
    const header = { alg: "RS256", typ: "JWT", kid: claims.kid };
    const payload = {
        apiKey: claims.apiKey,
        kid: claims.kid,
        iss: claims.iss,
        iat: Math.floor(Date.now() / 1000),
        origin: claims.origin,
    };
    const signingInput = `${stringToBase64Url(JSON.stringify(header))}.${stringToBase64Url(JSON.stringify(payload))}`;
    let key;
    let der = null;
    try {
        der = pkcs8ToDer(privateKey);
        key = await globalThis.crypto.subtle.importKey("pkcs8", der, { name: "RSASSA-PKCS1-v1_5", hash: "SHA-256" }, false, ["sign"]);
    }
    catch (e) {
        const decoded = der === null
            ? "the base64 body could not be decoded"
            : `decoded ${der.byteLength} bytes, expected 1218 for a 2048-bit key`;
        throw new Error(`${describe(e)} — the bundled widget signing key is not valid PKCS#8 ` +
            `(${decoded}). Check the WIDGET_JWT_PRIVATE_KEY build secret; a single ` +
            "dropped base64 character still decodes and produces exactly this error.");
    }
    let signature;
    try {
        signature = await globalThis.crypto.subtle.sign("RSASSA-PKCS1-v1_5", key, new TextEncoder().encode(signingInput));
    }
    catch (e) {
        throw new Error(`${describe(e)} — widget mint JWT signing failed.`);
    }
    return `${signingInput}.${bytesToBase64Url(new Uint8Array(signature))}`;
}
